export const Home = 'Home/';

export const GetSummary = Home + "Summary";
export const GetUpdates = Home + "Updates";
